<template>
	<div style="display: flex; height: 100%; max-height: 100%;">
		<div class="bl-card" v-if="data" style="height: calc(100% - 17px);" v-bl-layout="'column start stretch'">
			<div v-bl-layout="'center center'" style="margin: 5px 5px 0 5px;">
				<BlButton v-bl-flex icon="security_update_good" :label="updateStatus" @click="save()" :disabled="currentRequest" />
				<BlButton icon="cancel" class="dense outlined cancelBlButton" @click="cancel()" :disabled="currentRequest" />
			</div>

			<div v-bl-layout="'start baseline'" style="margin-bottom: -15px;">
				<h1 v-bl-flex>{{ bundle }}</h1>
				<div class="bl-chip" style="--bl-chip-color: var(--bl-primary); font-size: 12px;">{{ done.length + 1 }}/{{ todo.length }}</div>
			</div>

			<BlTabs v-model="filterList">
				<BlTab name="diff">
					<BlTabHeader :notification="conflictsCount">
						<icon>report</icon>
						Only conflicts
					</BlTabHeader>
				</BlTab>
				<BlTab name="all">
					<BlTabHeader>
						<icon>list</icon>
						All changes
					</BlTabHeader>
				</BlTab>
			</BlTabs>
			<div class="bl-light-scroll tree" style="overflow: auto; margin-top: -5px;" v-bl-flex>
				<ul>
					<BlNoData v-if="(filterList == 'all' ? data : conflicts).length == 0" />
					<li v-for="group in (filterList == 'all' ? data : conflicts)" :key="group.model">
						<span :style="{color: group.color}">
							<icon>{{ group.icon }}</icon>
							{{ group.model.split('.')[1] }}
						</span>
						<ul>
							<li v-for="(item, i) in group.items" :key="i" :class="{diff: item.diff, checked: item.checked}">
								<input type="checkbox" class="bl-checkbox" v-model="item.checked" @change="updateChecked(group.model, item)" />
								<div style="width: 70px; min-width: 70px;" @click="selectDiff(item)">
									<span class="status" style="--status-color: #499f49;" v-if="item.type == 'create'">
										<icon>add</icon>
										Create
									</span>
									<span class="status" style="--status-color: #a90505;" v-if="item.type == 'delete'">
										<icon>delete</icon>
										Delete
									</span>
									<span class="status" style="--status-color: #d5a54e;" v-if="item.type == 'update'">
										<icon>upgrade</icon>
										Update
									</span>
								</div>
								<div @click="selectDiff(item)">{{ item.name }}</div>
								<button class="bl-icon-button" v-if="item.diff" @click="selectDiff(item)">expand_content</button>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
		<div class="bl-card" style="flex: 1; height: calc(100% - 7px); padding: 0; overflow: hidden;">
			<div ref="codeEditor" style="width: 100%; height: 100%;"></div>
		</div>
	</div>
</template>

<script>
import { Api } from 'ModelBundle'
import { MonacoLoader } from 'InstallBundle'
import { Variables, Dialog, ViewLoader } from 'InterfaceBundle'

export default {
	name: 'InstallPostInstall',
	data() {
		return {
			data: null,
			conflicts: null,
			conflictsCount: null,
			bundle: null,
			done: [],
			todo: [],
			selectedDiff: null,
			settings: null,
			filterList: 'diff',
			currentRequest: false
		}
	},
	props: ["type"],
	created() {
		MonacoLoader.loadEditor(() => {
			let req = {settings: {}}
			req.settings['context("settings"):s.internal.install.editor.settings.get()'] = {
				data: 'local.settings'
			}

			Api.post('api/structure/', req).then(resp => {
				this.settings = resp.settings.data
				let options = this.settings?.editor ? this.settings.editor : {}
				if(!options.fontSize) options.fontSize = '12px'
				options.model = null
				if(!options.theme) options.theme = 'vs-' + Variables.theme
				options.automaticLayout = true
				this.editor = window.monaco.editor.createDiffEditor(this.$refs.codeEditor, options)
				this.loadModule()
			})
		})
	},
	unmounted(){
		clearInterval(this.updateInterval)
	},
	computed: {
		updateStatus: function() {
			return (this.done.length+1 === this.todo.length ? 'Finish update' : 'Update bundle')
		}
	},
	methods: {
		loadModule() {
			Api.get('/install-elements/post-' + this.type + '/').then(resp => {
				this.bundle = Object.keys(resp.data)[0]
				this.data = resp.data[this.bundle]
				this.conflicts = JSON.parse(JSON.stringify(this.data)).map(g => {
					g.items = g.items.filter(i => i.diff)
					return g
				}).filter(g => g.items.length)
				this.conflictsCount = this.conflicts.reduce((acc, g) => g.items.length + acc, 0)
				if(this.conflictsCount === 0) this.conflictsCount = false
				this.done = resp.done
				this.todo = resp.todo
				Variables.setGlobalLoading(false)
			})
		},
		selectDiff(item) {
			if(!item.diff) return
			const diffModel = {
				original: window.monaco.editor.createModel(this.toText(item.diff[0]), 'text'),
				modified: window.monaco.editor.createModel(this.toText(item.diff[1]), 'text')
			}
			this.editor.setModel(diffModel)
		},
		toText(item) {
			let ret = []
			for(let key in item) {
				ret.push('-------------------- ' + key + ' --------------------')
				if(Array.isArray(item[key])) {
					let isObjectArray = true
					for(let value of item[key]) {
						if(typeof value !== 'object') {
							isObjectArray = false
							break
						}
					}
					if(isObjectArray) {
						for(let value of item[key]) {
							ret.push(JSON.stringify(value, null, 4))
							if(value !== item[key][item[key].length - 1]) ret.push('')
						}
					} else ret.push(item[key])
				}
				else ret.push(item[key])
			}
			return ret.join("\n")
		},
		save() {
			if(this.conflictsCount) Dialog.confirm({
				title: this.updateStatus + ' ?',
				accept: 'Update',
				cancel: 'Cancel'
			}).then(() => this.doSave())
			else this.doSave()
		},
		doSave() {
			this.currentRequest = true
			Variables.setGlobalLoading(true)
			const req = {}
			req[this.bundle] = this.data.map(group => {
				return {
					model: group.model,
					items: group.items.filter(i => i.checked).map(i => i.name)
				}
			})
			Api.post('/install-elements/post-' + this.type + '/', {data: JSON.stringify(req)}).then(() => {
				if(this.done.length + 1 === this.todo.length) ViewLoader.update()
				else {
					this.loadModule()
					this.currentRequest = false
				}
			})
		},
		cancel() {
			Dialog.confirm({
				title: 'Cancel install ?',
				accept: 'Cancel install',
				cancel: 'Close'
			}).then(() => {
				this.currentRequest = true
				Api.get('/install-elements/cancel/')
				this.updateInterval = setInterval(function(){
					Api.get('interface/manifest.json')
					if(Variables.upgrading) {
						clearTimeout(this.updateInterval)
						ViewLoader.update()
					}
				}, 1000)
			})
		},
		updateChecked(model, item) {
			(this.filterList == 'diff' ? this.data : this.conflicts).find(g => g.model == model).items.find(i => i.name == item.name).checked = item.checked
		}
	}
}
</script>

<style scoped lang="scss">
	.cancelBlButton :deep(icon) {
		margin-right: -3px !important;
	}

	.tree {
		width: 350px;
		padding: 0;

		ul {
			list-style-type: none;
			margin: 0;
			padding: 0;
		}

		> ul {
			padding: 5px 10px;

			> li {
				position: relative;

				> span {
					background-color: var(--bl-surface);
					z-index: 2;
					position: absolute;
					display: flex;
					align-items: center;
					padding-right: 5px;
					font-weight: 500;

					> icon {
						font-size: 18px;
						margin-right: 4px;
					}
				}
			}

			> li::before {
				content: ' ';
				border-top: 1px solid var(--bl-border);
				width: 100%;
				height: 1px;
				display: block;
				position: absolute;
				margin-top: 9px;
			}
		}

		> ul > li > ul {
			padding: 30px 10px 10px 10px;

			> li {
				display: flex;
				align-items: center;

				input {
					margin-top: -2px;
					margin-right: 10px;
				}

				span.status {
					display: inline-flex;
					align-items: center;
					border: 1px solid var(--status-color);
					border-radius: 4px;
					padding: 2px 4px;
					font-size: 12px;
					font-weight: 500;
					background-color: color-mix(in srgb, var(--status-color) 5%, var(--bl-surface));
					color: var(--status-color);

					> icon {
						color: var(--status-color);
						font-size: 14px;
					}
				}
			}

			> li:not(.checked) span.status {
				text-decoration: line-through;
			}

			> li.diff {
				> div {
					font-weight: 500;
					cursor: pointer;
				}

				> button {
					font-size: 18px;
					padding: 0;
					margin-left: 5px;
				}
			}
		}
	}
</style>